<ng-container [ngSwitch]="displayType">
  <ng-template [ngSwitchCase]="'markerRow-fieldColum'">
    <ion-row class="ion-nowrap ion-align-items-center">
      <ion-col size="4" class="c-border-right">
        <ng-container *ngIf="sourceMarqueurs && sourceMarqueurs[index] as sourceMarqueur">
          <ng-container *ngIf="canEditDescription; else DisplayDescription">
            <strong>{{ sourceMarqueur?.label }} : </strong> <ion-input class="gl-input-highlight c-ion-input" (ionInput)="editDescription($event, sourceMarqueur, index)" type="text" [value]="sourceMarqueur.description"></ion-input>
          </ng-container>
          <ng-template #DisplayDescription>
            <strong>{{ sourceMarqueur?.label }} : </strong> {{ sourceMarqueur?.description }}
          </ng-template>
        </ng-container>
      </ion-col>
      <ng-container *ngFor="let fieldOrLabel of champs; let last=last">
        <ion-col size="4" [ngClass]="{'c-border-right': !last}">
          <app-c-form-dynamique-all-fields
            [modeShow]="modeShow"
            [forms]="forms"
            [blocName]="blocName"
            [fieldOrLabel]="fieldOrLabel"
            [display]="display"
            [context]="context"
            [observeSourcesArrFromParentPage]="observeSourcesArr"
            [step]="step"
            [bloc]="bloc"
            [etatId]="etatId"
            [mainFormOrSubForm]="'sub-form'"
          ></app-c-form-dynamique-all-fields>
        </ion-col>
      </ng-container>
    </ion-row>
  </ng-template>
  <!-- <ng-template [ngSwitchCase]="'markerColumn-fieldRow'">
    <ng-container *ngFor="let fieldOrLabel of champs">
      <app-c-form-dynamique-all-fields
        [modeShow]="modeShow"
        [forms]="forms"
        [blocName]="blocName"
        [fieldOrLabel]="fieldOrLabel"
        [display]="display"
        [context]="'preparation'"
        [observeSourcesArrFromParentPage]="observeSourcesArr"
        [step]="step"
        [bloc]="bloc"
        [mainFormOrSubForm]="'sub-form'"
      ></app-c-form-dynamique-all-fields>
    </ng-container>
  </ng-template> -->
</ng-container>
